import { mapGetters } from "vuex";
import { unitDefault, unitTypes } from "@/settings/unitTypes";

export default {
  computed: {
    ...mapGetters("auth", ["isMetric"])
  },
  methods: {
    transformPressure: function(valueStored, newUnit) {
      if (newUnit === "bar") return valueStored;
      if (newUnit === "kPa") return valueStored * 100;
      if (newUnit === "psi") return valueStored * 14.5037738007;
      if (newUnit === "atm") return valueStored * 1.01325;
    },
    transformTemperature: function(valueStored, newUnit) {
      if (newUnit === "°C") return valueStored;
      if (newUnit === "K") return valueStored + 273.15;
      if (newUnit === "°F") return valueStored * (9 / 5) + 32;
      if (newUnit === "°R") return valueStored * (9 / 5) + 491.67;
    },
    transformFlow: function(valueStored, newUnit) {
      if (newUnit === "l/h") return valueStored;
      if (newUnit === "m³/s") return valueStored / (3.6 * 10 ** 6);
      if (newUnit === "m³/h") return valueStored / 1000;
      if (newUnit === "GPM") return valueStored / 227;
      if (newUnit === "ft³/h") return valueStored / 28.317;
      if (newUnit === "MMSCFD") return valueStored / 326.99;
    },
    transformAngularSpeed: function(valueStored, newUnit) {
      if (newUnit === "rad/s") return valueStored;
      if (newUnit === "rpm") return valueStored / 0.10472;
    },
    transformPercentage: function(valueStored, newUnit) {
      if (newUnit === "%") return valueStored;
      if (newUnit === "relative") return valueStored / 100;
    },
    transformPower: function(valueStored, newUnit) {
      if (newUnit === "kW") return valueStored;
      if (newUnit === "hp") return valueStored * 1.34102;
    },
    transformVolume: function(valueStored, newUnit) {
      if (newUnit === "l") return valueStored;
      if (newUnit === "m³") return valueStored / 1000;
      if (newUnit === "gal") return valueStored / 4.54609;
    },
    transformMassFlow: function(valueStored, newUnit) {
      if (newUnit === "kg/h") return valueStored;
      if (newUnit === "lb/h") return valueStored * 2.204621;
    },
    transformLength: function(valueStored, newUnit) {
      if (newUnit === "m") return valueStored;
      if (newUnit === "in") return valueStored / 0.0254;
      if (newUnit === "ft") return valueStored / 0.3048;
    },
    transformVibration: function(valueStored, newUnit) {
      if (newUnit === "μm") return valueStored;
      if (newUnit === "mils") return valueStored / 25.4;
    },
    transformUnit: function(value, type, unit) {
      if (type === unitTypes.pressure)
        return this.transformPressure(value, unit);
      if (type === unitTypes.temperature)
        return this.transformTemperature(value, unit);
      if (type === unitTypes.flow || type === unitTypes.outputFlow)
        return this.transformFlow(value, unit);
      if (type === unitTypes.percentage)
        return this.transformPercentage(value, unit);
      if (type === unitTypes.angularSpeed)
        return this.transformAngularSpeed(value, unit);
      if (type === unitTypes.power) return this.transformPower(value, unit);
      if (type === unitTypes.volume) return this.transformVolume(value, unit);
      if (type === unitTypes.massFlow)
        return this.transformMassFlow(value, unit);
      if (type === unitTypes.length) return this.transformLength(value, unit);
      if (type === unitTypes.vibration)
        return this.transformVibration(value, unit);
      if (
        type === unitTypes.voltage ||
        type === unitTypes.frequency ||
        type === unitTypes.electricCurrent ||
        type === unitTypes.capacity ||
        type === unitTypes.pH ||
        type === unitTypes.conductivity ||
        type === unitTypes.electricalPower ||
        type === unitTypes.unique ||
        type === unitTypes.steps ||
        type === unitTypes.deathLine
      )
        return value;
    },
    globalInitialUnit: function(type) {
      if (type === unitTypes.pressure)
        return this.isMetric
          ? unitDefault.pressure.metric
          : unitDefault.pressure.imperial;
      if (type === unitTypes.temperature)
        return this.isMetric
          ? unitDefault.temperature.metric
          : unitDefault.temperature.imperial;
      if (type === unitTypes.flow)
        return this.isMetric
          ? unitDefault.flow.metric
          : unitDefault.flow.imperial;
      if (type === unitTypes.percentage) return unitDefault.percentage.metric;
      if (type === unitTypes.angularSpeed)
        return this.isMetric
          ? unitDefault.angularSpeed.metric
          : unitDefault.angularSpeed.imperial;
      if (type === unitTypes.power)
        return this.isMetric
          ? unitDefault.power.metric
          : unitDefault.power.imperial;
      if (type === unitTypes.voltage) return unitDefault.voltage.metric;
      if (type === unitTypes.frequency) return unitDefault.frequency.metric;
      if (type === unitTypes.electricCurrent)
        return unitDefault.electricCurrent.metric;
      if (type === unitTypes.massFlow)
        return this.isMetric
          ? unitDefault.massFlow.metric
          : unitDefault.massFlow.imperial;
      if (type === unitTypes.capacity) return unitDefault.capacity.metric;
      if (type === unitTypes.volume) return unitDefault.volume.metric;
      if (type === unitTypes.pH) return unitDefault.pH.metric;
      if (type === unitTypes.vibration) return unitDefault.vibration.metric;
      if (type === unitTypes.length) return unitDefault.length.metric;
      if (type === unitTypes.electricalPower)
        return unitDefault.electricalPower.metric;
      if (type === unitTypes.conductivity)
        return unitDefault.conductivity.metric;
    }
  }
};
